module.exports = __webpack_public_path__ + "img/9788934929086.a54e108b.jpg";